import { Settings, User, Building2, MapPin, MapPinOff, Loader2, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useAuth } from '@/lib/contexts/auth-context';
import { useTheme } from '@/lib/contexts/theme-context';
import { useGeolocation } from '@/lib/contexts/device-permissions-context';
import { useTranslation } from 'react-i18next';

export function MobileHeaderHome() {
    const { t } = useTranslation();
    const { theme } = useTheme();
    const navigate = useNavigate();
    const { user, logout } = useAuth();
    const { isEnabled, isLoading, toggleGeolocation, permissionStatus } = useGeolocation();
    const hasCompany = Boolean(user?.company_uniq_id ?? user?.company?.uniq_id);
    const isIndividual = user?.role === 'user';

    const handleToggleGeolocation = async () => {
        await toggleGeolocation();
    };

    // Déterminer l'icône et le style du bouton
    const isActive = isEnabled && permissionStatus === 'granted';
    const isDenied = permissionStatus === 'denied';

    return (
        <div className="mobile-header-home md:hidden flex items-center justify-between gap-3 px-5 py-4">
            <div className="theme-logo-container flex-1 h-8 min-w-32">
                <img
                    src={theme.logo}
                    alt={theme.logoAlt}
                    className="theme-logo h-full w-full object-contain object-left"
                />
            </div>
            <div className="flex items-center gap-[12px]">
                {/* Bouton géolocalisation */}
                <Button
                    variant="outline"
                    color="neutral"
                    size="auto"
                    onClick={handleToggleGeolocation}
                    disabled={isLoading}
                    className={`rounded-[8px] h-[40px] w-[40px] ${
                        isDenied ? 'bg-error/10 border-error/20 text-error hover:bg-error/20' : ''
                    }`}
                    title={
                        isActive
                            ? t('common:geolocalisationActiveeCliquerPourDesactiver')
                            : isDenied
                              ? t('common:geolocalisationRefuseeCliquerPourReessayer')
                              : t('common:activerLaGeolocalisation')
                    }
                >
                    {isLoading ? (
                        <Loader2 className="h-5 w-5 animate-spin" />
                    ) : isActive ? (
                        <MapPin className="h-5 w-5" />
                    ) : (
                        <MapPinOff className="h-5 w-5" />
                    )}
                </Button>
                <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                        <Button
                            variant="outline"
                            color="neutral"
                            size="auto"
                            className="rounded-[8px] h-[40px] w-[40px]"
                        >
                            <Settings className="h-5 w-5" />
                        </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="end" className="w-48">
                        <DropdownMenuItem onClick={() => navigate('/settings/account')} className="cursor-pointer">
                            <User className="w-4 h-4 mr-2" />
                            {t('common:monCompte')}
                        </DropdownMenuItem>
                        {hasCompany && !isIndividual && (
                            <DropdownMenuItem onClick={() => navigate('/settings/company')} className="cursor-pointer">
                                <Building2 className="w-4 h-4 mr-2" />
                                {t('common:monEntreprise')}
                            </DropdownMenuItem>
                        )}
                        <DropdownMenuSeparator />
                        <DropdownMenuItem
                            onClick={logout}
                            className="cursor-pointer text-destructive focus:text-destructive"
                        >
                            <LogOut className="w-4 h-4 mr-2" />
                            {t('common:deconnexion')}
                        </DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
            </div>
        </div>
    );
}
